// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Immunization view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...ImmunizationRender }`, [ImmunizationRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const ImmunizationRenderFragment = graphql(`
  fragment ImmunizationRender on Immunization @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    status
    statusReason {
      text
      coding {
        system
        code
        display
      }
    }
    vaccineCode {
      text
      coding {
        system
        code
        display
      }
    }
    patient {
      reference
      type
      display
    }
    encounter {
      reference
      type
      display
    }
    occurrenceDateTime
    occurrenceString
    recorded
    primarySource
    reportOrigin {
      text
      coding {
        system
        code
        display
      }
    }
    location {
      reference
      type
      display
    }
    manufacturer {
      reference
      type
      display
    }
    lotNumber
    expirationDate
    site {
      text
      coding {
        system
        code
        display
      }
    }
    route {
      text
      coding {
        system
        code
        display
      }
    }
    doseQuantity {
      value
      comparator
      unit
      system
      code
    }
    performer {
      function {
        text
        coding {
          system
          code
          display
        }
      }
      actor {
        reference
        type
        display
      }
    }
    note {
      authorReference {
        reference
        type
        display
      }
      authorString
      time
      text
    }
    reasonCode {
      text
      coding {
        system
        code
        display
      }
    }
    reasonReference {
      reference
      type
      display
    }
    isSubpotent
    subpotentReason {
      text
      coding {
        system
        code
        display
      }
    }
    education {
      documentType
      reference
      publicationDate
      presentationDate
    }
    programEligibility {
      text
      coding {
        system
        code
        display
      }
    }
    fundingSource {
      text
      coding {
        system
        code
        display
      }
    }
    reaction {
      date
      detail {
        reference
        type
        display
      }
      reported
    }
    protocolApplied {
      series
      authority {
        reference
        type
        display
      }
      targetDisease {
        text
        coding {
          system
          code
          display
        }
      }
      doseNumberPositiveInt
      doseNumberString
      seriesDosesPositiveInt
      seriesDosesString
    }
  }
`);
